import React, { useState } from 'react';

import HistoryNavLink from './HistoryNavlinks';

const History = () => {
  const [activeTitle, setActiveTitle] = useState('SMS History');

  return (
    <>
      {/* <HeaderCardContent name={`Billing - ${activeTitle}`} /> */}
      <HistoryNavLink setActiveTitle={setActiveTitle} />
    </>
  );
};

export default History;
